"use client";

import { useEffect } from "react";

import type { PlaceholderConfigs } from "../../../../types/injectables";
import type { Ad } from "../../../../types/ads/adResource";

import { tagAndBatch } from "./tagAndBatch";

const PreLoadArticleAds = ({
  batchToLoad,
}: {
  batchToLoad: (Ad | PlaceholderConfigs)[];
}) => {
  useEffect(() => {
    tagAndBatch(batchToLoad);
  }, [batchToLoad]);
  return null;
};

export { PreLoadArticleAds };
